<template>
  <div>

    <!-- TRIGGER BUTTON (parent just uses this) -->
    <b-button
      variant="primary"
      @click="open"
      size="sm"

    >
      Manage Shifts
    </b-button>

    <!-- MAIN MODAL -->
    <b-modal
      ref="shiftModal"
      size="lg"
      title="Company Shifts"
      hide-footer
    >

      <!-- ACTION BAR -->
      <div class="d-flex justify-content-between mb-3">
        <a
          class="btn btn-primary"
          @click="openCreate"

        >
          + New Shift
      </a>

        <div>
          <b-button
            variant="danger"
            class="mr-2"
            :disabled="!selected.length"
            @click="bulkToggle(false)"

          >
            Deactivate
          </b-button>

          <a
            class="btn btn-outline-primary"
            :disabled="!selected.length"
            @click="bulkToggle(true)"

          >
            Activate
        </a>
        </div>
      </div>

      <!-- TABLE -->
      <b-table
        :items="shifts"
        :fields="fields"
        bordered
        small
        responsive
      >

        <template #cell(select)="r">
          <b-form-checkbox
            v-model="selected"
            :value="r.item.id"
          />
        </template>

        <template #cell(is_active)="r">
          <b-badge
            :variant="r.item.is_active ? 'success' : 'danger'"
          >
            {{ r.item.is_active ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>

        <template #cell(actions)="r">
          <b-button
            size="sm"
            variant="primary"
            @click="openEdit(r.item)"

          >
            Edit
          </b-button>
        </template>

      </b-table>

      <!-- DRAG SORT -->
      <h6 class="mt-3">Reorder</h6>

      <draggable
        v-model="shifts"
        handle=".drag"
        @end="saveSort"
      >
        <div
          v-for="s in shifts"
          :key="s.id"
          class="p-2 border mb-1 d-flex align-items-center"
        >
          <i class="fa fa-bars drag mr-2"></i>
          {{ s.name }}
        </div>
      </draggable>

    </b-modal>


    <!-- CREATE / EDIT MODAL -->
    <b-modal
      ref="formModal"
      :title="isEdit ? 'Edit Shift' : 'Create Shift'"
      hide-footer
      @hidden="resetForm"
    >

      <b-alert
        variant="danger"
        v-if="errors.length"
        show
      >
        <ul>
          <li v-for="e in errors" :key="e">{{ e }}</li>
        </ul>
      </b-alert>

      <b-form @submit.prevent="submit">

        <b-form-group label="Name">
          <b-form-input v-model="form.name" required />
        </b-form-group>

        <b-form-group label="Start Time">
          <b-form-input
            type="time"
            v-model="form.start_time"
            required
          />
        </b-form-group>

        <b-form-group label="End Time">
          <b-form-input
            type="time"
            v-model="form.end_time"
            required
          />
        </b-form-group>

        <b-form-checkbox v-model="form.spans_next_day">
          Spans next day
        </b-form-checkbox>

        <b-form-checkbox v-model="form.is_active">
          Active
        </b-form-checkbox>

        <b-form-group label="Sort Order">
          <b-form-input
            type="number"
            v-model="form.sort_order"
          />
        </b-form-group>

        <div class="text-right">

          <b-button
            variant="secondary"
            @click="$refs.formModal.hide()"
          >
            Cancel
          </b-button>

          <b-button
            variant="primary"
            type="submit"
            :disabled="loading"
          >
            {{ isEdit ? 'Update' : 'Save' }}
          </b-button>

          <b-button
            v-if="isEdit"
            variant="danger"
            class="ml-2"
            @click="destroy"
          >
            Delete
          </b-button>

        </div>

      </b-form>
    </b-modal>

  </div>
</template>
<script>
import axios from 'axios'
import draggable from 'vuedraggable'

export default {
  components: { draggable },


  data() {
    return {
      shifts: [],
      selected: [],
      loading: false,
      isEdit: false,
      errors: [],

      form: {
        id: null,
        name: '',
        start_time: '',
        end_time: '',
        spans_next_day: false,
        is_active: true,
        sort_order: 0
      },

      fields: [
        { key: 'select', label: '' },
        { key: 'name' },
        { key: 'start_time' },
        { key: 'end_time' },
        { key: 'is_active' },
        { key: 'actions', label: '' }
      ]
    }
  },

  computed: {
    canView() {
      return this.permissions.includes('shift.view')
    },
    canCreate() {
      return this.permissions.includes('shift.create')
    },
    canUpdate() {
      return this.permissions.includes('shift.update')
    }
  },

  methods: {

    open() {
      this.fetch()
      this.$refs.shiftModal.show()
    },

    async fetch() {
      let { data } = await axios.get(
        `/api/company-shifts`
      )
      this.shifts = data
      this.selected = []
    },

    openCreate() {
      this.isEdit = false
      this.$refs.formModal.show()
    },

    openEdit(shift) {
      this.isEdit = true
      this.form = { ...shift }
      this.$refs.formModal.show()
    },

    resetForm() {
      this.errors = []
      this.form = {
        id: null,
        name: '',
        start_time: '',
        end_time: '',
        spans_next_day: false,
        is_active: true,
        sort_order: 0
      }
    },

    async submit() {
      this.errors = []
      this.loading = true

      try {

        if (this.isEdit) {
          await axios.put(
            `/api/company-shifts/${this.form.id}`,
            this.form
          )
        } else {
          await axios.post(
            `/api/company-shifts`,
            {
              ...this.form,
            }
          )
        }

        this.$refs.formModal.hide()
        this.fetch()

      } catch (e) {
        if (e.response?.data?.errors) {
          Object.values(e.response.data.errors)
            .forEach(v => this.errors.push(v[0]))
        }
      }

      this.loading = false
    },

    async destroy() {
      if (!confirm('Delete shift?')) return

      await axios.delete(
        `/api/company-shifts/${this.form.id}`
      )

      this.$refs.formModal.hide()
      this.fetch()
    },

    async saveSort() {

      let payload = this.shifts.map((s, i) => ({
        id: s.id,
        sort_order: i
      }))

      await axios.post(
        '/api/company-shifts/reorder',
        { items: payload }
      )
    },

    async bulkToggle(state) {
      await axios.post(
        '/api/company-shifts/bulk-toggle',
        {
          ids: this.selected,
          state
        }
      )

      this.fetch()
    }
  }
}
</script>
